module.exports = __webpack_public_path__ + "static/media/ci_red_edit.99d1f3ff.svg";